import { jsxs, jsx } from "react/jsx-runtime";
import { useState, useRef, useCallback, useEffect } from "react";
import { isTouchDevice, throttle } from "@perxis-auto/shared";
import AntSelect from "antd/es/select";
import classnames from "../../utils/classnames.js";
import Icon from "../Icon/Icon.js";
import Typography from "../Typography/Typography.js";
import './Select.css';/* empty css            */
const Select = ({
  value,
  label,
  className,
  labelClassName,
  popupClassName,
  wrapperClassName,
  disabled,
  allowClear = true,
  showSearch = false,
  closeOnScroll = true,
  notFoundContent = null,
  listHeight = 185,
  placeholder = "Выберите",
  maxTagCount = "responsive",
  suffixIcon = /* @__PURE__ */ jsx(Icon, { name: "down" }),
  clearIcon = /* @__PURE__ */ jsx(Icon, { name: "cross" }),
  removeIcon = /* @__PURE__ */ jsx(Icon, { name: "cross" }),
  getPopupContainer = (triggerNode) => {
    var _a;
    return (_a = triggerNode.parentNode) == null ? void 0 : _a.parentNode;
  },
  onChange,
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const isMobile = isTouchDevice();
  const selectRef = useRef(null);
  let clear;
  if (!allowClear) {
    clear = false;
  } else if (clearIcon) {
    clear = { clearIcon };
  } else {
    clear = true;
  }
  const handleBlur = useCallback(() => {
    setTimeout(() => {
      if (selectRef == null ? void 0 : selectRef.current) {
        selectRef.current.blur();
      }
    }, 0);
  }, [selectRef]);
  const handleScroll = (event) => {
    const target = event.target;
    const isScrollDropdownList = target.nodeName !== "#document" && target.classList.contains("rc-virtual-list-holder");
    if (!isScrollDropdownList && isFocused) {
      handleBlur();
    }
  };
  useEffect(() => {
    if (closeOnScroll && !isMobile) {
      const scrollThrottle = throttle(handleScroll, 100);
      window.addEventListener("scroll", scrollThrottle, true);
      return () => {
        window.removeEventListener("scroll", scrollThrottle, true);
      };
    }
  }, [closeOnScroll, isMobile, isFocused]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classnames(
        [
          "perxis-auto-select-wrapper",
          {
            "perxis-auto-select-wrapper--disabled": disabled
          }
        ],
        wrapperClassName
      ),
      children: [
        !!label && /* @__PURE__ */ jsx(Typography.Paragraph, { color: "darkest", level: "main", className: classnames("perxis-auto-select-label", labelClassName), children: label }),
        /* @__PURE__ */ jsx(
          AntSelect,
          {
            value,
            ref: selectRef,
            disabled,
            allowClear: clear,
            listHeight,
            placeholder,
            showSearch,
            suffixIcon,
            removeIcon,
            maxTagCount,
            notFoundContent,
            getPopupContainer,
            popupClassName: classnames("perxis-auto-select-dropdown", popupClassName),
            className: classnames(
              [
                "perxis-auto-select",
                {
                  "perxis-auto-select-filled": (Array.isArray(value) ? !!value.length : !!value) && !isFocused
                }
              ],
              className
            ),
            onFocus: () => {
              setIsFocused(true);
            },
            onBlur: () => {
              setIsFocused(false);
              handleBlur();
            },
            onChange: (...values) => {
              if (props.mode !== "multiple") {
                setIsFocused(false);
                handleBlur();
              }
              onChange == null ? void 0 : onChange(...values);
            },
            ...props
          }
        )
      ]
    }
  );
};
Select.Option = AntSelect.Option;
export {
  Select as default
};
//# sourceMappingURL=Select.js.map
